<template>
  <v-dialog v-model="show" max-width="500px" persistent>
    <v-card>
      <ModelTitle title="Select a Collection" :showBackButton="false"  />
      <!-- <v-card-title class="headline">Select a Collection</v-card-title> -->

      <v-card-text>
        <div v-if="collections.length === 0" class="text-center">
          <v-alert type="warning" outlined>
            Force Collection is enabled in settings, but you have no collections yet.
            Please create a collection or turn off force collection.
          </v-alert>
        </div>

        <v-list v-else dense>
          <v-list-item
            v-for="collection in collections"
            :key="collection.id"
            @click="selectCollection(collection)"
            class="pointer"
          >
            <v-list-item-content>
              <v-list-item-title>{{ collection.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions v-if="collections.length === 0">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectCollectionDialog",
  props: {
    value: { type: Boolean, default: false },
    collections: { type: Array, default: () => [] }
  },
  data() {
    return {
      show: this.value
    };
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    selectCollection(collection) {
      this.$emit("select", collection);
      this.show = false;
    },
    close() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>